import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "bootstrap";
import pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts.js";
pdfMake.vfs = pdfFonts;
import vue3GoogleLogin from "vue3-google-login";
import Vue3Geolocation from "vue3-geolocation";
import VueGoogleMaps from "@fawmi/vue-google-maps";
import { plugin, defaultConfig } from "@formkit/vue";
import { GOOGLE_CLIENT_ID, KEY_MAP } from "./env";
import "bootstrap/dist/css/bootstrap.css";
import "@formkit/themes/genesis";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/js/bootstrap.bundle";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "animate.css";
//para toasts
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import "@/components/Utils/css/custom-toast-styles.css";
import { initTheme } from "./services/helpers/themeHelper";
import "procedures-engine/style.css";

initTheme();

createApp(App)
  .use(plugin, defaultConfig)
  .use(store)
  .use(router)
  .use(Vue3Geolocation)
  .use(VueGoogleMaps, {
    load: {
      key: KEY_MAP,
      autobindAllEvents: true,
      libraries: "places",
    },
  })
  .use(vue3GoogleLogin, {
    clientId: GOOGLE_CLIENT_ID,
    buttonConfig: { theme: "filled_blue", shape: "rectangular" },
  })
  .use(Toast, {
    position: "top-right",
    timeout: 3048,
    closeOnClick: false,
    pauseOnFocusLoss: false,
    pauseOnHover: false,
    draggable: true,
    draggablePercent: 0.8,
    showCloseButtonOnHover: true,
    hideProgressBar: false,
    closeButton: "button",
    icon: true,
    rtl: false,
  })
  .mount("#app");
